import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ReviewsViewerSSR } from "../apps/reviews/ReviewsViewerSSR";

export const Template = (
    props: Immutable<templates.ReviewsPageTemplate>,
): React.JSX.Element => {
    return <ReviewsViewerSSR {...props} />;
};
